import * as d3 from 'd3'
export default {

  methods: {
    
    draw_chartTimeline() {    

      let month = this.timeline.styles.month
      let year = this.timeline.styles.year

      let timeline = this.canvasChart
      .append('g')
      .attr('transform', `translate(0, ${this.chart.height + .5})`)
      .style('font-family', 'roboto')

      // Month
      this.timeline.month.forEach((d,i)=> {
        let momth = this.timeline.styles.month.type == 'num' ? d.num : d.name
        this.gmx_Text(timeline, '', d.mx, month.textY, month.tSize, month.tColor, 'middle', '', momth)
        if(i==0) return
        this.gmx_Line(timeline, d.sx, d.sx, 0, month.lineY, '#bcbcbc', .5, 1)
      })
        
      // Year
      this.timeline.year.forEach((d,i)=> {
        this.gmx_Text(timeline, '', d.mx, year.textY, year.tSize, year.tColor, 'middle', '', d.name)
        if(i==0) return
        this.gmx_Line(timeline, d.sx, d.sx, month.lineY, year.lineY, '#bcbcbc', .5, 1)
      })
    },


  }
}
